import { View } from 'backbone.marionette';
import {Prototype} from '../decorators/Prototype';
import {CURRENT_USER} from '../../js/resources/SessionObjects';

/**
 * BaseView to share funtionality with the all views
 *
 * @class BaseView
 * @extends Mn.View
 *
 */
export class BaseView extends View {

    constructor () {
        let instance = super(...arguments);

        /**
         * If view has "appFeature" property, check if it's allowed and then
         * render nothing or render alternative template
         */
        if (this.appFeature) {

            if (!CURRENT_USER.isFeatureEnabled(this.appFeature)) {
                return new Mn.View({
                    template: instance.disabledTemplate || (() => "")
                });
            }
        }

        return instance;
    }

    /**
     * render the view without error message
     * because it was already destroyed
     */
    safeRender() {

        if(!this.isDestroyed()) {
            this.render();
        }
    }

    render () {
        super.render();

        // as we're having more generic markup it's harder to find related code
        // this adds data-view="ClassName" to root element for all views extended from BaseView
        if (this.constructor.name && _.includes(['local', 'develop', 'qa', 'staging'], ENV)) {
            this.el.setAttribute('data-view', this.constructor.name);
        }
    }

}

export { Prototype };



// WEBPACK FOOTER //
// ./shared/view/BaseView.js